import { withBrowserContext } from '../../src/FiverrContext/withBrowserContext';
import BaseI18nProvider from '../../src/I18nProvider';

export const I18nProvider = withBrowserContext(BaseI18nProvider);
